import { createFileRoute } from "@tanstack/react-router"
import { PageHeader } from "@/components/layout"
import {
	type GameCoverageRow,
	GamesCoverageGrid,
	RefreshAllCoverageButton,
} from "@/features/catalogue-quality/GamesCoverageGrid"
import { useGamesCoverage } from "@/queries/games/use-games-coverage"

export const Route = createFileRoute("/games/")({
	component: GamesPage,
})

function GamesPage() {
	const query = useGamesCoverage()

	const rows: GameCoverageRow[] = (query.data ?? []).map((row) => ({
		gameSlug: row.gameSlug,
		gameName: row.gameName,
		image: row.image ?? null,
		catalogueQuality: row.catalogueQuality,
		totalExpansions: row.totalExpansions,
		cards: row.cards,
		sealed: row.sealed,
		verified: row.verified,
		featuredExpansionsCount: row.featuredExpansionsCount,
		lastComputedAt: row.lastComputedAt ?? null,
		lastCardImportAt: row.lastCardImportAt ?? null,
		lastSealedImportAt: row.lastSealedImportAt ?? null,
		lastDeployAt: row.lastDeployAt ?? null,
		priceImport: row.priceImport,
	}))

	if (query.error) {
		return (
			<div className="flex flex-col gap-6 p-6">
				<PageHeader title="Games" />
				<p className="text-bad">
					Failed to load games coverage: {(query.error as Error).message}
				</p>
			</div>
		)
	}

	const isEmpty = !query.isLoading && rows.length === 0

	return (
		<div className="flex h-[calc(100vh-3rem)] flex-col gap-6 p-6">
			<PageHeader
				title="Games"
				count={query.isLoading ? undefined : rows.length}
				description={
					isEmpty
						? "No coverage data yet. Run the seed script or trigger an importer to populate it."
						: undefined
				}
				actions={<RefreshAllCoverageButton rows={rows} />}
			/>
			<div className="min-h-0 flex-1">
				<GamesCoverageGrid rows={rows} loading={query.isLoading} />
			</div>
		</div>
	)
}
